import React from "react";
import { Box, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import legalbirdLogo from "../../assets/img/logo/legalbird-logo-white.svg";
import Typography from "@mui/material/Typography";
import { Link } from "react-router";
import footerTransition from "../../assets/img/background/Footer_overlay.svg";
import footerStyle from "./footerStyle";
import dayjs from "dayjs";

type FooterProps = {
  hideProductLinks?: boolean;
};

export default function Footer({ hideProductLinks = false }: FooterProps) {
  return (
    <Box sx={footerStyle.footer}>
      <Box component={"img"} sx={footerStyle.footerTransition} src={footerTransition} alt={"footertransition"} />
      <Box component={"footer"}>
        <Box component={"nav"} aria-label={"Footernavigation"} sx={footerStyle.footerNav}>
          <Grid container sx={footerStyle.footerContainer}>
            <Grid
              size={{
                xs: 12,
                md: 3,
                lg: 2
              }}>
              <Box component={"img"} src={legalbirdLogo} alt={"Legalbird"} sx={footerStyle.logo} />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 9,
                lg: 8
              }}>
              <Grid container spacing={4}>
                <Grid
                  size={{
                    xs: 6,
                    md: 3,
                    lg: 2
                  }}>
                  <Typography variant={"h6"} sx={footerStyle.categoryHeadline}>
                    Legalbird
                  </Typography>
                  <Stack spacing={2}>
                    <Typography component={Link} to={"/ueber-uns"} sx={{
                      color: "inherit"
                    }}>
                      Über uns
                    </Typography>
                    <Typography component={Link} to={"/kontakt"} sx={{
                      color: "inherit"
                    }}>
                      Kontakt
                    </Typography>
                    <Typography component={Link} to={"/jobs"} sx={{
                      color: "inherit"
                    }}>
                      Karriere
                    </Typography>
                    <Typography component={Link} to={"/lp/partneranwalt-werden"} sx={{
                      color: "inherit"
                    }}>
                      Partneranwalt werden
                    </Typography>
                  </Stack>
                </Grid>
                {!hideProductLinks && (
                  <>
                    <Grid
                      size={{
                        xs: 6,
                        md: 3,
                        lg: 2
                      }}>
                      <Typography variant={"h6"} sx={footerStyle.categoryHeadline}>
                        Rechtsbereiche
                      </Typography>
                      <Stack spacing={2}>
                        <Typography component={Link} to={"/familienrecht"} sx={{
                          color: "inherit"
                        }}>
                          Familienrecht
                        </Typography>
                        <Typography component={Link} to={"/arbeitsrecht"} sx={{
                          color: "inherit"
                        }}>
                          Arbeitsrecht
                        </Typography>
                        <Typography component={Link} to={"/verkehrsrecht"} sx={{
                          color: "inherit"
                        }}>
                          Verkehrsrecht
                        </Typography>
                        <Typography component={Link} to={"/vertragsrecht"} sx={{
                          color: "inherit"
                        }}>
                          Vertragsrecht
                        </Typography>
                      </Stack>
                    </Grid>
                    <Grid
                      size={{
                        xs: 6,
                        md: 3,
                        lg: 2
                      }}>
                      <Typography variant={"h6"} sx={footerStyle.categoryHeadline}>
                        Ratgeber
                      </Typography>
                      <Stack spacing={2}>
                        <Typography component={Link} to={"/ratgeber/familienrecht"} sx={{
                          color: "inherit"
                        }}>
                          Familienrecht
                        </Typography>
                        <Typography component={Link} to={"/ratgeber/arbeitsrecht"} sx={{
                          color: "inherit"
                        }}>
                          Arbeitsrecht
                        </Typography>
                        <Typography component={Link} to={"/ratgeber/verkehrsrecht"} sx={{
                          color: "inherit"
                        }}>
                          Verkehrsrecht
                        </Typography>
                      </Stack>
                    </Grid>
                  </>
                )}
                <Grid
                  size={{
                    xs: 6,
                    md: 3,
                    lg: 2
                  }}>
                  <Typography variant={"h6"} sx={footerStyle.categoryHeadline}>
                    Rechtliches
                  </Typography>
                  <Stack spacing={2}>
                    <Typography component={Link} to={"/agb"} sx={{
                      color: "inherit"
                    }}>
                      AGB
                    </Typography>
                    <Typography component={Link} to={"/datenschutz"} sx={{
                      color: "inherit"
                    }}>
                      Datenschutz
                    </Typography>
                    <Typography component={Link} to={"/impressum"} sx={{
                      color: "inherit"
                    }}>
                      Impressum
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
            <Grid size={12}>
              <Typography
                sx={[{
                  color: "inherit"
                }, footerStyle.trademark]}>
                © Legalbird {dayjs().format("YYYY")}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}
